import { DownloadType } from '../../../download-types/shared';

export class Download {
  _id?: string;
  name: string = '';
  file: string = '';
  type: DownloadType;
  position: number = 0;
  locales: String[] = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/download.model.ts